import React from "react"
import { useSelector } from "react-redux"
import MainPaper from "src/features/Components/MainPaper"
import { makeStyles } from "@material-ui/core/styles"
import { get } from "lodash"
import Typography from "@material-ui/core/Typography"
import Grid from "@material-ui/core/Grid"
import Avatar from "@material-ui/core/Avatar"
import NoImage from "src/assets/no-image.jpg"

const useStyles = makeStyles((theme) => ({
  root: { marginBottom: theme.spacing(2) },
  title: { marginBottom: theme.spacing(2) },
  avatar: { width: 100, height: 100 },
}))

function Index() {
  const classes = useStyles()
  const detail = useSelector((state) => state.medicine.detail)

  return (
    <MainPaper elevation={0} className={classes.root}>
      <Grid container justifyContent="space-between">
        <Grid item>
          <Typography variant="h6">
            {get(detail, "presentation.search_name")}
          </Typography>
          <Typography variant="body2" gutterBottom>
            {get(detail, "multiplier")}{" "}
            {get(detail, "presentation.presentation_name.name")} x{" "}
            {get(detail, "presentation.quantity")}{" "}
            {get(detail, "presentation.presentation_unit.name")} /{" "}
            {get(detail, "container.name")}
          </Typography>
          <Typography variant="body2">
            {get(detail, "presentation.registration_number.licensee.full_name")}
          </Typography>
          <Typography variant="body2">
            {get(detail, "station.full_name")} ● {get(detail, "barcode")}
          </Typography>
        </Grid>
        <Grid item>
          <Avatar
            className={classes.avatar}
            variant="rounded"
            src={get(detail, "cover_img") || NoImage}
          />
        </Grid>
      </Grid>
    </MainPaper>
  )
}

export default Index
